import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { INK, STATUS } from 'Utils/styleTokens';

const copyToClipboard = (text) => {
  try {
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text);
  } catch (e) {
    /* clipboard blocked: the text is still on screen to select */
  }
};

/**
 * The explanation of one failure: plain-language headline, what to do next, then the full raw
 * text the service returned (scrollable, copyable, never truncated). Pass the result of
 * Utils/errorText.explainJobError plus any `service` you know.
 */
export function ErrorDetailsPanel({ headline, nextStep, detail, code, httpStatus, service, compact = false }) {
  return (
    <div className='sg-error-details' data-testid='error-details'>
      {headline && <div style={{ fontWeight: 600, color: STATUS.danger.text }}>{headline}</div>}
      {nextStep && <div className='sg-small' style={{ color: INK[700], marginTop: 2 }}>{nextStep}</div>}
      {(code || httpStatus || service || detail) && (
        <div style={{ background: INK[50], padding: compact ? 8 : 12, borderRadius: 6, marginTop: 8 }}>
          <div className='sg-small' style={{ display: 'flex', gap: 18, flexWrap: 'wrap', marginBottom: detail ? 8 : 0, color: INK[500] }}>
            {code && <span><strong>Error:</strong> {code}</span>}
            {httpStatus && <span><strong>HTTP:</strong> {httpStatus}</span>}
            {service && <span><strong>Service:</strong> {service}</span>}
            <span style={{ flex: 1 }} />
            {detail && (
              <button type='button' className='btn btn-sm btn-outline-secondary' onClick={() => copyToClipboard(detail)}>
                Copy
              </button>
            )}
          </div>
          {/* Full text as returned by the worker (stored server-side up to 16k chars). Scrolls; shown untruncated. */}
          <div className='sg-mono' style={{ maxHeight: compact ? 220 : 460, overflow: 'auto', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', fontSize: 12 }}>
            {detail || 'No additional detail was captured for this failure.'}
          </div>
        </div>
      )}
    </div>
  );
}

/** The same panel in a dialog, for cards that only have room for the headline. */
export function ErrorDetailsDialog({ show, onHide, title = 'Error details', ...panel }) {
  return (
    <Modal show={show} onHide={onHide} size='lg' aria-labelledby='error-details-title'>
      <Modal.Header closeButton>
        <Modal.Title id='error-details-title' style={{ fontSize: 16 }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ErrorDetailsPanel {...panel} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant='outline-secondary' onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ErrorDetailsPanel;
